import { render } from "./CourseSelectionView.vue?vue&type=template&id=1d45b380"
import script from "./CourseSelectionView.vue?vue&type=script&lang=js"
export * from "./CourseSelectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__